var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_18360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_18360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3341 11.0771V7.07715H10.6674V11.0771H8.66742V5.07715H23.3341V11.0771H21.3341ZM23.7444 16.4105C24.1222 16.4105 24.4389 16.2827 24.6944 16.0271C24.95 15.7716 25.0778 15.4549 25.0778 15.0771C25.0778 14.6994 24.95 14.3827 24.6944 14.1271C24.4389 13.8716 24.1222 13.7438 23.7444 13.7438C23.3666 13.7438 23.05 13.8716 22.7944 14.1271C22.5389 14.3827 22.4111 14.6994 22.4111 15.0771C22.4111 15.4549 22.5389 15.7716 22.7944 16.0271C23.05 16.2827 23.3666 16.4105 23.7444 16.4105ZM21.3341 25.3335V19.6411H10.6674V25.3335H21.3341ZM23.3341 27.3335H8.66742V22.0001H3.71875V14.4105C3.71875 13.466 4.04142 12.6744 4.68675 12.0355C5.33208 11.3966 6.12053 11.0771 7.05208 11.0771H24.9494C25.8939 11.0771 26.6855 11.3966 27.3244 12.0355C27.9633 12.6744 28.2828 13.466 28.2828 14.4105V22.0001H23.3341V27.3335ZM26.2828 20.0001V14.4105C26.2828 14.0327 26.155 13.716 25.8994 13.4605C25.6439 13.2049 25.3272 13.0771 24.9494 13.0771H7.05208C6.67431 13.0771 6.35764 13.2049 6.10208 13.4605C5.84653 13.716 5.71875 14.0327 5.71875 14.4105V20.0001H8.66742V17.6411H23.3341V20.0001H26.2828Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.360851306e43c7b6ce8f56c601f6a28c.svg";
export { ForwardRef as ReactComponent };